import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

// navItems: array of either
//   { to, label, active } - a plain nav link
//   { label, dropdown: [{ to, label, active }] } - a dropdown trigger
// cart: optional { itemCount, onClick } to render the cart icon before the Follow button
function Header({ navItems = [], cart }) {
  return (
    <header className="substack-header">
      <div className="header-logo">
        <Link to="/">
          <img
            src="https://daily-obx-cdn.b-cdn.net/newsletter-images/theobxbeachbumlogo.png"
            alt="the OBX Beach Bum"
            className="main-logo"
          />
        </Link>
      </div>
      <nav className="header-nav">
        {navItems.map((item) =>
          item.dropdown ? (
            <div className="nav-dropdown" key={item.label}>
              <span className="nav-item dropdown-trigger">{item.label} ▾</span>
              <div className="dropdown-menu">
                {item.dropdown.map((sub) => (
                  <Link
                    key={sub.to}
                    to={sub.to}
                    className={`dropdown-item${sub.active ? ' active' : ''}`}
                  >
                    {sub.label}
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <Link
              key={item.to}
              to={item.to}
              className={`nav-item${item.active ? ' active' : ''}`}
            >
              {item.label}
            </Link>
          )
        )}
        {cart && (
          <button className="cart-nav-btn" onClick={cart.onClick} aria-label="View cart">
            <ShoppingCart size={20} />
            {cart.itemCount > 0 && <span className="cart-badge">{cart.itemCount}</span>}
          </button>
        )}
        <Link to="/subscribe" className="nav-item subscribe-btn">Follow</Link>
      </nav>
    </header>
  );
}

export default Header;
